import { take } from 'rxjs/operators';
import { Observable as WindowedObservable } from 'windowed-observable';
import { BasketItem } from '../../models';
export class BasketDataTransformer {
    constructor(hrefResolverService, contentService, basketConfigService) {
        this.hrefResolverService = hrefResolverService;
        this.contentService = contentService;
        this.basketConfigService = basketConfigService;
        this.productPageUrl = this.hrefResolverService.getResolvedUrl('productPage');
        this.errorHandler$ = new WindowedObservable('errorHandler$');
        this.basketConfigService.configDataLoaded$.pipe(take(1)).subscribe(() => {
            const deniedProductTypes = this.basketConfigService.getDeniedProductTypesConfig();
            this.deniedProductTypes = deniedProductTypes || [];
            this.dataPointsConfig = this.basketConfigService.getDataPointsConfig();
        });
    }
    static isEmpty(text) {
        return !text || !text.trim() || text.trim() === '-';
    }
    static hasProductId(response, portfolioId) {
        const productId = 'fundHeader.custom-metadata.productId';
        return !!((response === null || response === void 0 ? void 0 : response.data)
            && response.data[portfolioId]
            && response.data[portfolioId][productId]
            && BasketDataTransformer.getDisplayValue(response.data[portfolioId][productId])
            && BasketDataTransformer.getDisplayValue(response.data[portfolioId][productId]) !== '-');
    }
    static getDisplayValue(datumElement) {
        return typeof datumElement === 'boolean' ? datumElement : datumElement === null || datumElement === void 0 ? void 0 : datumElement.d;
    }
    static handleCallbackError(callBack) {
        if (!callBack) {
            throw new Error('callback function must be provided');
        }
    }
    onErrorHandler(callBack) {
        BasketDataTransformer.handleCallbackError(callBack);
        return this.errorHandler$.subscribe(callBack);
    }
    errorHandlerUnSubscribe(callBack) {
        BasketDataTransformer.handleCallbackError(callBack);
        return this.errorHandler$.unsubscribe(callBack);
    }
    mapApiResponseToBasketItems(response, portfolioIds) {
        return portfolioIds
            .filter((portfolioId) => BasketDataTransformer.hasProductId(response, portfolioId))
            .map((portfolioId) => this.mapResponseItemToBasketItem(response, portfolioId));
    }
    mapResponseItemToBasketItem(response, portfolioId) {
        const responseDataForFund = response && response.data[portfolioId];
        if (!responseDataForFund || this.hasDeniedProductTypes(response, portfolioId)) {
            return null;
        }
        const basketItemSource = this.getBasketItemSourceObject(responseDataForFund);
        const basketItem = new BasketItem(basketItemSource.productId, basketItemSource.ticker, basketItemSource.fundName, this.getProductPageUrl(basketItemSource.productId), this.isActive(basketItemSource.active), basketItemSource.unlinked);
        basketItem.shareClass = basketItemSource.shareClass
            ? basketItemSource.shareClass
            : basketItem.shareClass;
        basketItem.assetClass = basketItemSource.assetClass
            ? basketItemSource.assetClass
            : basketItem.assetClass;
        basketItem.sfdr = basketItemSource.sfdr ? basketItemSource.sfdr : basketItem.sfdr;
        return basketItem;
    }
    getBasketItemSourceObject(responseDataForFund) {
        const basketItemSource = {};
        Object.keys(this.dataPointsConfig).forEach((property) => {
            const propertyValue = this.dataPointsConfig[property];
            if (Array.isArray(propertyValue)) {
                basketItemSource[property] = [];
                propertyValue.forEach((val) => {
                    var _a;
                    const displayValue = (_a = BasketDataTransformer.getDisplayValue(responseDataForFund[val])) === null || _a === void 0 ? void 0 : _a.toString();
                    if (!BasketDataTransformer.isEmpty(displayValue)) {
                        basketItemSource[property].push(displayValue);
                    }
                });
            }
            else {
                basketItemSource[property] = responseDataForFund
                    && responseDataForFund[propertyValue]
                    && BasketDataTransformer.getDisplayValue(responseDataForFund[propertyValue]);
            }
        });
        return basketItemSource;
    }
    getProductPageUrl(portfolioId) {
        return `${this.productPageUrl}/${portfolioId}/`;
    }
    isActive(activeProperty) {
        const activeDcr = this.contentService.get('ACTIVE', 'active');
        const activeTranslatedDcr = this.contentService.get('ACTIVE_TRANSLATED', 'aktiv');
        const activePropertyTransformed = activeProperty.toLowerCase();
        return (activePropertyTransformed.includes(activeDcr === null || activeDcr === void 0 ? void 0 : activeDcr.toLowerCase())
            || activePropertyTransformed.includes(activeTranslatedDcr === null || activeTranslatedDcr === void 0 ? void 0 : activeTranslatedDcr.toLocaleLowerCase()));
    }
    static isDeniedType(response, portfolioId, deniedType) {
        const productType = 'fundHeader.custom-metadata.productType';
        return (BasketDataTransformer.getDisplayValue(response === null || response === void 0 ? void 0 : response.data[portfolioId][productType]) === deniedType);
    }
    hasDeniedProductTypes(response, portfolioId) {
        var _a;
        let denyProductT;
        const hasDeniedProductTypes = (_a = this.deniedProductTypes) === null || _a === void 0 ? void 0 : _a.some((denyProductType) => {
            denyProductT = denyProductType;
            return BasketDataTransformer.isDeniedType(response, portfolioId, denyProductType);
        });
        if (hasDeniedProductTypes) {
            this.publishDeniedProductType(portfolioId, denyProductT);
        }
        return hasDeniedProductTypes;
    }
    publishDeniedProductType(portfolioId, denyProductType) {
        this.errorHandler$.publish({
            errorType: 'productType',
            message: `productType is not supported: ${denyProductType}`,
            portfolioId,
        });
    }
}
